import { Collapse, Drawer } from "antd";


export function PoliticaPrivacidade({open, setOpen, onClose, onChange}) {

    const items = [
        {
            key: '1',
            label: 'Quais dados o Meu Contador Online coleta e usa?',
            children: <p>
                Para que possamos prestar os nossos serviços, torna-se imprescindível a coleta de algumas informações a seu respeito e de sua empresa.
                <strong>O Meu Contador Online poderá coletar dados pessoais fornecidos diretamente por você, por terceiros ou coletados de forma automática</strong>, de acordo com o serviço prestado. Veja abaixo, com um pouco mais de detalhe, as formas de coleta de dados pessoais e de sua empresa:
            </p>,
        },
        {
            key: '2',
            label: 'Dados pessoais e de sua empresa fornecidos diretamente por você:',
            children: <p>
                O Meu Contador Online coletará todos os dados pessoais e de sua empresa inseridos ou encaminhados ao acessar um dos nossos canais (sites ou aplicativos, ou e-mail) ou ao contratar produtos e/ou serviços fornecidos.
            </p>,
        },

        {
            key: '3',
            label: 'Dados pessoais e de sua empresa fornecidos por terceiros:',
            children: <p>
                O Meu Contador Online pode receber seus dados pessoais e de sua empresa por intermédio de terceiros, sejam parceiros ou prestadores de serviços, que possuam algum relacionamento com você. É possível, ainda, que o Meu Contador Online colete: dados de bases públicas, disponibilizadas por autoridades (como a Receita Federal, por exemplo) ou por terceiros, ou até mesmo dados tornados públicos por você em websites ou rede sociais, sempre respeitando a sua privacidade.            </p>,
        },

        {
            key: '4',
            label: 'Dados pessoais e de sua empresa coletados automaticamente:',
            children: <p>
                O Meu Contador Online também pode coletar uma série de informações de modo automático e para tanto se utiliza de algumas tecnologias de mercado, como cookies, pixel tags, beacons e local shared objects, com o propósito de melhorar a sua experiência de navegação em nossos serviços, de acordo com os seus hábitos e as suas preferências.
            </p>
        },

        {
            key: '5',
            label: 'Para toda a coleta de dados pessoais e de sua empresa, o Meu Contador Online sempre seguirá as seguintes regras essenciais:',
            children:

                <ul>
                    <li>Apenas serão coletadas informações imprescindíveis para a prestação dos serviços oferecidos.</li>
                    <li>Se necessário, lhe pediremos autorização ou lhe avisaremos para coleta de novos dados, acompanhado da devida justificativa.</li>
                    <li>Os dados pessoais e de sua empresa coletados somente serão utilizados para cumprir com as finalidades informadas a você;</li>
                </ul>

        },

        {
            key: '5',
            label: 'O que são e como utilizamos cookies?',
            children: <p>
                Cookies são arquivos ou informações que podem ser armazenadas em seus dispositivos quando você visita os websites ou utiliza os serviços on-line do Meu Contador Online. Geralmente, um cookie contém o nome do site que o originou, seu tempo de vida e um valor, que é gerado aleatoriamente.

                O Meu Contador Online utiliza cookies para facilitar o uso e melhor adaptar seu website e aplicações aos interesses e necessidades de seus Usuários, bem como para auxiliar e melhorar suas estruturas e seus conteúdos. Os cookies também podem ser utilizados para acelerar suas atividades e experiências futuras em nossos serviços.

                Por meio de cookies, o Site armazena informações sobre as atividades do navegador, incluindo endereço IP e a página acessada. Esses registros de atividades (logs), que poderão compreender dados como o endereço IP, as ações efetuadas no Site, as páginas acessadas, as datas e horários de cada ação e de acesso a cada página do Site e as informações sobre o dispositivo utilizado, versão de sistema operacional, navegador, dentre outros aplicativos instalados, serão utilizados apenas para fins estatísticos e de métricas dos serviços disponibilizados, para a investigação de fraudes ou de alterações indevidas em seus sistemas e cadastros, não tendo como finalidade o fornecimento dos dados a terceiros sem autorização expressa do Usuário.
            </p>
        },

        {
            key: '6',
            label: 'Tipos de Cookies / O que eles fazem?',
            children:
                <p>
                    <strong>Necessários</strong>
                    <p>Os cookies são essenciais para que o website do Meu Contador Online permita que você navegue corretamente, bem como faça o uso de todas as funcionalidades disponíveis.</p>

                    <strong>Desempenho</strong>
                    <p>Os cookies nos ajudam a entender como os visitantes interagem com a página do Meu Contador Online, fornecendo informações sobre as áreas visitadas, o tempo de visita ao site e quaisquer problemas encontrados, como mensagens de erro.</p>

                    <strong>Funcionais</strong>
                    <p>Os cookies permitem que a página do Meu Contador Online se lembre de suas escolhas, para proporcionar uma experiência personalizada. Também, possibilitam que os Usuários assistam a vídeos e utilizem ferramentas sociais, campos para comentários, fóruns, dentre outros.</p>

                    <strong>Marketing</strong>
                    <p>Os cookies são utilizados para fornecer mais conteúdo relevante e do interesse dos Usuários. Podem ser utilizados para apresentar publicidade com um maior direcionamento ou limitar o número que esta é veiculada, nas páginas do Meu Contador Online. Também, permitem a medição da eficácia de uma campanha publicitária lançada.

                        A qualquer momento você, Usuário de nossos serviços, poderá revogar a sua autorização quanto à utilização dos cookies, utilizando, para tanto, as configurações de seu navegador de preferência. Contudo, alertamos que, de acordo com a escolha realizada, certas funcionalidades dos nossos serviços poderão não funcionar da maneira idealmente esperada, bem como aspectos de segurança das informações e prevenção a fraudes poderão ser impactadas.</p>


                </p>
        },

        {
            key: '7',
            label: 'Com quem compartilhamos os seus dados pessoais e de sua empresa?',
            children:
                <p>
                    <span>O Meu Contador Online, por vezes, precisará compartilhar os seus dados pessoais com terceiros. As situações que envolverão o compartilhamento de suas informações são:</span>

                    <p>
                        Com empresas parceiras e fornecedores, no desenvolvimento e prestação de serviços disponibilizados a você, desde que devidamente aprovadas pelos processos de segurança do Meu Contador Online;
                    </p>

                    <p>
                        Com autoridades, entidades governamentais ou outros terceiros, para a proteção dos interesses do Meu Contador Online em qualquer tipo de conflito, incluindo ações judiciais e processos administrativos;
                    </p>

                    <p>
                        No caso de transações e operações societárias envolvendo o Meu Contador Online, hipótese em que a transferência das informações será necessária para a continuidade dos serviços;
                    </p>

                    <p>
                        Mediante ordem judicial ou pelo requerimento de autoridades administrativas que detenham competência legal para a sua requisição.
                    </p>
                </p>
        },

        {
            key: '8',
            label: 'Por que tratamos seus dados pessoais e de sua empresa?',
            children:
                <p>
                    <span>
                        O tratamento de dados pessoais e de sua empresa pelo Meu Contador Online tem diversas finalidades, a depender do seu relacionamento conosco. Assim, apresentamos abaixo, de forma não exaustiva, as principais hipóteses em que trataremos as suas informações pessoais e de sua empresa:
                    </span>

                    <p>
                        <strong>Para a execução dos serviços ou diligências preliminares: Para a prestação dos serviços das empresas do Meu Contador Online: </strong>
                    </p>

                    <p>
                        serviços contábeis, como geração de balaço patrimonial e balancetes
                    </p>

                    <p>
                        serviços de poio administrativo, como cálculo de impostos e folha de pagamento
                    </p>

                    <p>
                        serviços de legalização de empresas, como abertura de empresa, alteração contratual, encerramento de empresa, registro em órgãos de classe obtenção de licença e alvará de funcionamento.
                    </p>

                    <p>
                        Para o relacionamento e oferecimento de informações relacionadas aos produtos e serviços contratados pelos clientes do Meu Contador Online.
                    </p>

                    <p>
                        <strong>Caso as empresas do Meu Contador Online tenham que cumprir alguma obrigação legal ou regulatória:</strong>
                        Atendimento de obrigações legais, tais como, mas não se limitando, a resoluções, circulares, atos normativos, comunicados de órgãos competentes (por exemplo: Conselho Regional de Contabilidade, Receita Federal do Brasil, Bacen, entre outros) os quais definem, por exemplo: (i) medidas de segurança para evitar abusos e fraudes; procedimentos para detecção de transações que desviem de padrões normais; (iii) gravação, quando necessário, de telefonemas, e-mails, chats; (iv) prevenção à lavagem de dinheiro e financiamento ao terrorismo.
                    </p>

                    <p>
                        <strong>
                            Na persecução do interesse legítimo das empresas que compõem o Meu Contador Online, sempre no limite de sua expectativa, e nunca em prejuízo de seus interesses, direitos e liberdades fundamentais:
                        </strong>
                    </p>

                    <p>
                        Na construção e avaliação do perfil de seus clientes, para oferecimento de produtos personalizados e compatíveis com as suas necessidades. Isso poderá ser alcançado, por exemplo, a partir (i) da análise de seus hábitos e preferências nos vários canais de interação com as empresas do Meu Contador Online, (ii) do compartilhamento de dados com outras empresas do Meu Contador Online, principalmente quando você é cliente ou potencial cliente dessa outra entidade;
                        Na implantação e desenvolvimento de nossos produtos e serviços;
                        No estabelecimento de estatísticas, testes e avaliações para pesquisa e desenvolvimento, visando o gerenciamento e avaliação de riscos do negócio, a melhoria e/ou criação de novos produtos;
                        Em casos de reclamação quando há citação do Meu Contador Online em redes sociais ou plataformas específicas, com a finalidade de resolver os pontos reclamados, bem como adotar as medidas necessárias para resolver a situação da melhor maneira possível.
                    </p>

                    <p>
                        Para a condução de atividades que visam prevenir a ocorrência de fraudes.
                    </p>

                    <p>
                        Quando a empresa do Meu Contador Online avalia o score de crédito de seus clientes ou prospects para a disponibilização de serviços desta natureza.
                    </p>

                    <p>
                        <strong>Por meio de autorização concedida por você, como em processos de:</strong>

                        <p>Envio de marketing indireto de produtos de terceiros;</p>
                        <p>Em processos de relacionamento com os clientes do Meu Contador Online, quando a atividade envolver dados pessoais sensíveis.</p>
                    </p>

                    <p>
                        <strong>Como mantemos os seus dados pessoais e de sua empresa seguros?</strong>

                        <p>
                            Qualquer dado pessoal em posse do Meu Contador Online será armazenado de acordo com os mais rígidos padrões de segurança adotados pelo mercado, o que inclui a adoção de medidas como:
                        </p>

                        <p>Proteção contra acesso não autorizado;</p>
                        <p>Acesso restrito de pessoas ao local onde são armazenadas as informações pessoais;</p>
                        <p>
                            Adotar procedimentos para que agentes, funcionários internos ou parceiros externos que realizarem o tratamento de dados pessoais se comprometam a manter o sigilo absoluto das informações, adotando as melhores práticas para manuseio destes dados, conforme determinado nas políticas e procedimentos corporativos;
                        </p>

                        <p>
                            <span>
                                Além dos esforços técnicos, o Meu Contador Online também adota medidas institucionais visando a proteção de dados pessoais, de modo que mantém programa de governança e privacidade aplicado às suas atividades e estrutura de governança, constantemente atualizado.

                                Nenhuma transmissão de informações é totalmente segura, pois sempre estará suscetível à ocorrência de falhas técnicas, malwares e/ou ações similares. Nesse sentido, o Meu Contador Online adota os melhores esforços para preservar a sua privacidade e proteger os seus dados pessoais.

                                De qualquer forma, na remota hipótese de incidência de episódios desta natureza, o Meu Contador Online garante o pleno esforço para remediar as consequências do evento, sempre garantindo a devida transparência a você.
                            </span>
                        </p>
                    </p>
                </p>
        },

        {
            key: '9',
            label: 'Por quanto tempo armazenaremos os seus dados pessoais e de sua empresa?',
            children:
                <p>
                    Os dados pessoais e de sua empresa, tratados pelo Meu Contador Online, serão eliminados quando não forem mais necessários aos fins para os quais foram coletados, ou quando solicitado por você, exceto na hipótese de necessidade de cumprimento de obrigação legal ou regulatória, transferência a terceiro – desde que respeitados os requisitos de tratamento de dados – e uso exclusivo do Meu Contador Online, inclusive para o exercício de seus direitos em processos judiciais ou administrativos.

                    <p>
                        <strong>Quais são os meus direitos como titular de dados pessoais?</strong>
                    </p>

                    <p>
                        Em cumprimento da regulamentação aplicável, no que diz respeito ao tratamento de dados pessoais, o Meu Contador Online respeita e garante, ao Usuário, a possibilidade de apresentar solicitações a partir do início da vigência da Lei Geral de Proteção de Dados, baseadas nos seguintes direitos:

                        <p>i. Confirmação da existência de tratamento;</p>
                        <p>ii. Acesso aos dados;</p>
                        <p>iii. Correção de dados incompletos, inexatos ou desatualizados;</p>
                        <p>iv. Anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade com a lei;</p>
                        <p>v. Portabilidade dos dados a outro fornecedor de serviço ou produto, mediante requisição expressa pelo Usuário;</p>
                        <p>vi. Eliminação dos dados tratados com consentimento do Usuário;</p>
                        <p>vii. Obtenção de informações sobre as entidades públicas ou privadas com as quais o Meu Contador Online compartilhou os seus dados;</p>
                        <p>viii. Informação sobre a possibilidade de o Usuário não fornecer o consentimento, bem como de ser informado sobre as consequências em caso de negativa;</p>
                        <p>ix. Revogação do consentimento.</p>
                    </p>

                    <p>
                        Parte dos direitos acima expostos poderá ser exercida diretamente por você, a partir da gestão de informações de cadastro, enquanto outra parte dependerá do envio de requisição por meio dos nossos canais de atendimento, para posterior avaliação e adoção de providências necessárias.
                    </p>

                    <p>
                        O Usuário fica ciente, por meio da leitura deste documento, que a eventual solicitação de exclusão de informações essenciais para a gestão de seu cadastro junto ao Meu Contador Online, quando passível de aplicação, implicará no término de sua relação contratual, com o consequente cancelamento dos serviços então prestados.
                    </p>

                    <p>
                        O Meu Contador Online empreenderá todos os esforços razoáveis para atender as requisições feitas pelos Titulares, no menor tempo possível. No entanto, fatores justificáveis, poderão atrasar ou impedir o seu rápido atendimento, sendo certo que, em caso de demora, a O Meu Contador Online apresentará ao Usuário os devidos motivos.
                    </p>

                    <p>
                        <strong>
                            Por fim, o Usuário deve estar ciente que a sua requisição poderá ser legalmente rejeitada, seja por motivos formais (a exemplo de sua incapacidade de comprovar sua identidade) ou legais (a exemplo do pedido de exclusão de dados cuja manutenção é livre exercício de direito pelo Meu Contador Online), sendo certo que, na hipótese de impossibilidade de atendimento destas requisições, o Meu Contador Online apresentará ao Usuário, as justificativas razoáveis.
                        </strong>
                    </p>



                </p>

        },


    ];

    return (
        <>
            <Drawer
                title="Política de Privacidade de Dados"
                closable={{ 'aria-label': 'Close Button' }}
                onClose={onClose}
                open={open}
            >
                <p><strong>Ao prosseguir com o formulário, você concorda com nossa política de privacidade de dados.</strong></p>
                <p>
                    O Meu Contador Online, representado pelas empresas Mais Gestão Estratégica de Negócios LTDA, CNPJ 23.791.830/0001-80 e Meu Contador Contabilidade LTDA, CNPJ 26.639.624/0001-47, oferece serviços de tecnologia, apoio administrativo e serviços contábeis para sua empresa. E, mais do que isso, o Meu Contador Online quer garantir transparência no relacionamento e segurança para você. Por isso, contamos com ferramentas avançadas de controle de privacidade e trabalhamos constantemente para proteger seus dados.

                    Aqui, você fica por dentro do tratamento de dados feito pelo Meu Contador Online em:

                    - serviços contábeis, como geração de balaço patrimonial e balancetes
                    - serviços de poio administrativo, como cálculo de impostos e folha de pagamento
                    - serviços de legalização de empresas, como abertura de empresa, alteração contratual, encerramento de empresa, registro em órgãos de classe obtenção de licença e alvará de funcionamento.
                </p>
                <p>
                    <Collapse items={items} defaultActiveKey={['1']} onChange={onChange} />
                </p>
            </Drawer>
        </>
    );
}
